// extracted by mini-css-extract-plugin
export default {"PaymentFormContainer":"PaymentScreen_PaymentFormContainer__j4tvB"};